import axios from '../utils/request'

const GetPlanTaskExecuteData = () => {
  return axios.get('GetPlanTaskExecuteData', { })
}

const TaskExecute = (AutoID) => {
  return axios.get('TaskExecute?AutoID=' + AutoID, { })
}

const AddressSyncAddressInfo = (fid) => {
  return axios.get('AddressSync_AddressInfo?fid=' + fid)
}

const AddressSyncAddressInfoInitialization = () => {
  return axios.get('AddressSync_AddressInfoInitialization', { })
}

const Address2SyncAddressInfoInitialization = () => {
  return axios.get('AddressSync2_AddressInfoInitialization', { })
}

const UpdateTaskExecuteDataCkey = (loginInfo) => {
  return axios.post('UpdateTaskExecuteDataCkey', {
    ...loginInfo
  })
}

export {
  GetPlanTaskExecuteData,
  UpdateTaskExecuteDataCkey,
  TaskExecute,
  AddressSyncAddressInfo,
  AddressSyncAddressInfoInitialization,
  Address2SyncAddressInfoInitialization
}
